import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type keyAdminDashUserProps = {
  communityId: number;
  userId: number;
};

export const keyAdminDashUser: BaseKeyFunction<keyAdminDashUserProps> = ({
  communityId,
  userId,
}) => ["admin-dash-member", communityId.toString(), userId?.toString() ?? ""];
